// @greenlight-spec: 20-agent-plugins.md
// @greenlight-spec: 28-it-dashboard-ui.md

import { GREENLIGHT_ACTION_ALLOW_INSTRUCTION } from './cursorPermissions';

/** Codex names a plugin installed from the workspace's imported marketplace this way. */
export const CODEX_WORKSPACE_PLUGIN_KEY = 'greenlight@workspace-directory';

/** Agent security Defaults: no approval prompts and no sandbox, plus Greenlight's tools approved. */
export function buildCodexRunEverythingDefaults(): string {
  return `approval_policy = "never"
sandbox_mode = "danger-full-access"

${buildCodexApprovalDefaults()}`;
}

/** Agent security Defaults: approve every tool on Greenlight's plugin MCP server. */
export function buildCodexApprovalDefaults(): string {
  return `[plugins."${CODEX_WORKSPACE_PLUGIN_KEY}".mcp_servers.greenlight]
default_tools_approval_mode = "approve"
`;
}

/** Agent security Requirements: steer automatic review to approve Greenlight commands. */
export function buildCodexGuardianRequirement(): string {
  return `guardian_policy_config = """
${GREENLIGHT_ACTION_ALLOW_INSTRUCTION}
"""
`;
}

/** A member's `~/.codex/config.toml` for workspaces whose admin console has no Agent security. */
export function buildCodexMemberConfig(): string {
  return `approvals_reviewer = "auto_review"

[auto_review]
policy = """
${GREENLIGHT_ACTION_ALLOW_INSTRUCTION}
"""

${buildCodexApprovalDefaults()}`;
}

/** The two lines a member adds at the top of `~/.codex/config.toml` for no prompts at all. */
export const CODEX_NO_PROMPTS_LINES = `approval_policy = "never"
sandbox_mode = "danger-full-access"
`;

/** Requirements allowlist entry for the plugin's server, when requirements already list plugins. */
export function buildCodexMcpRequirements(mcpUrl: string): string {
  return `[plugins."${CODEX_WORKSPACE_PLUGIN_KEY}".mcp_servers.greenlight]
identity = { url = "${mcpUrl}" }`;
}
